/**
 * Public MDI heatmap — vanilla port of the previous SVG implementation.
 */

const byId = (id) => document.getElementById(id);
const qs = (selector) => document.querySelector(selector);

function appendHtml(element, html) {
    element.insertAdjacentHTML('beforeend', html);
}

function copyAttributes(from, to) {
    [...from.attributes].forEach((attribute) => {
        to.setAttribute(attribute.name, from.getAttribute(attribute.name) ?? '');
    });
}

function createSvgFromHtml(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();

    return template.content.firstElementChild;
}

let mdi_data = {};
let mdi_labels = [];
let mdi_sub_labels = [];
let mdi_descriptions = [];

const globalDataScale = 10;

let scale = 1;
let selected = null;
let prev = null;
let selected2 = null;
let prev2 = null;
let focus_x = null;
let focus_y = null;
let focus_x2 = null;
let focus_y2 = null;
let default_focus_use = null;
let default_focus_use2 = null;
let default_focus_rect = null;
let default_focus_rect_horizontal = null;
let svg_sub = null;
let width = 0;
let offset = { x: 0, y: 0 };
let size = 70;
let svg = null;
let txt_size = 5;
let alter_y = null;
let alter_x = null;
let block_size_global = 50;

const labelBackground = '#393e44';

const R_low = 10;
const G_low = 226;
const B_low = 255;
const R_high = 4;
const G_high = 41;
const B_high = 129;

function rgb2hex(red, green, blue) {
    const rgb = blue | (green << 8) | (red << 16);

    return `#${(0x1000000 + rgb).toString(16).slice(1)}`;
}

function getHEX(val) {
    const R = (R_high - R_low) * val + R_low;
    const G = (G_high - G_low) * val + G_low;
    const B = (B_high - B_low) * val + B_low;

    return rgb2hex(R, G, B);
}

function sortByKey(array, key) {
    return array.sort((a, b) => {
        const x = a[key[0]][key[1]];
        const y = b[key[0]][key[1]];

        return x < y ? -1 : x > y ? 1 : 0;
    });
}

function getDes(val, des) {
    if (des <= 0) {
        return `With a tally of <b>${val}</b> points,<br> ${Math.abs(des)} points above the average.`;
    }

    return `With a tally of <b>${val}</b> points,<br> ${Math.abs(des)} points below the average.`;
}

function loadSelectLists() {
    const category = byId('category');
    const newshouseA = byId('newshouse-a');
    const newshouseB = byId('newshouse-b');

    if (!category || !newshouseA || !newshouseB) {
        return;
    }

    const appendOption = (select, value, text, selected = false) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = text;
        option.selected = selected;
        select.appendChild(option);
    };

    appendOption(category, '', 'Please select one');
    appendOption(newshouseA, '', 'Please select one');
    appendOption(newshouseA, 'All', 'All', true);
    appendOption(newshouseB, '', 'Please select one');
}

function reset_selected() {
    if (prev !== null) {
        selected.setAttribute('x', prev.getAttribute('x'));
        selected.setAttribute('y', prev.getAttribute('y'));
        selected.setAttribute('height', prev.getAttribute('height'));
        selected.setAttribute('width', prev.getAttribute('width'));
        selected.setAttribute('stroke-width', prev.getAttribute('stroke-width'));
        selected.setAttribute('stroke', prev.getAttribute('stroke'));
    }

    const focusUse = byId('mdi_focus_use');
    if (focusUse && default_focus_use) {
        copyAttributes(default_focus_use, focusUse);
    }

    focus_x = null;

    const focusRect = byId('mdi_focus_rect');
    if (focusRect && default_focus_rect) {
        copyAttributes(default_focus_rect, focusRect);
    }

    focus_y = null;

    const focusRectHorizontal = byId('mdi_focus_rect_horizontal');
    if (focusRectHorizontal && default_focus_rect_horizontal) {
        copyAttributes(default_focus_rect_horizontal, focusRectHorizontal);
    }

    alter_y = null;
    alter_x = null;

    clearEl(byId('mdi_svg_sub-wrap'));
}

function reset_selected2() {
    if (prev2 !== null) {
        selected2.setAttribute('x', prev2.getAttribute('x'));
        selected2.setAttribute('y', prev2.getAttribute('y'));
        selected2.setAttribute('height', prev2.getAttribute('height'));
        selected2.setAttribute('width', prev2.getAttribute('width'));
        selected2.setAttribute('stroke-width', prev2.getAttribute('stroke-width'));
        selected2.setAttribute('stroke', prev2.getAttribute('stroke'));
    }

    const focusUse2 = byId('mdi_focus_use2');
    if (focusUse2 && default_focus_use2) {
        copyAttributes(default_focus_use2, focusUse2);
    }

    clearEl(byId('mdi_svg_sub2-wrap'));
}

function clearEl(element) {
    if (element) {
        element.innerHTML = '';
    }
}

function showVertDrill(x, stop_try) {
    const focusRect = byId('mdi_focus_rect');
    focusRect.setAttribute('x', String(offset.x + size * x));
    focusRect.setAttribute('y', String(offset.y));
    focusRect.setAttribute('stroke-width', '3');
    focusRect.setAttribute('stroke', 'white');

    const val_x = mdi_data[Object.keys(mdi_data)[x]];
    const h = Object.keys(val_x).length - 1;

    focusRect.setAttribute('width', String(size));
    focusRect.setAttribute('height', String(h * size));

    focus_x = x;

    if (stop_try !== true) {
        tryFocusBlock();
    }
}

function showHorizDrill(y, stop_try) {
    const focusRectHorizontal = byId('mdi_focus_rect_horizontal');
    focusRectHorizontal.setAttribute('x', String(offset.x));
    focusRectHorizontal.setAttribute('y', String(offset.y + size * y));
    focusRectHorizontal.setAttribute('stroke-width', '3');
    focusRectHorizontal.setAttribute('stroke', 'white');

    const h = Object.keys(mdi_data).length;

    focusRectHorizontal.setAttribute('width', String(h * size));
    focusRectHorizontal.setAttribute('height', String(size));

    focus_y = y;

    if (stop_try !== true) {
        tryFocusBlock();
    }
}

function tryFocusBlock() {
    if (focus_x !== null && focus_y !== null) {
        const elem = byId(`${focus_x}_${focus_y}`);
        showDrill(elem, focus_x, focus_y);
    }
}

function tryFocusBlock2() {
    if (focus_x2 !== null && focus_y2 !== null) {
        const elem = byId(`${focus_x2}_${focus_y2}`);
        showDrill2(elem, focus_x2, focus_y2);
    }
}

function reSortByCriteria(index) {
    mdi_data = sortByKey(mdi_data, [index + 1, 0]);
    loadSelectLists();
    reloadSvg();
}

function reSortByMedia(index) {
    const orderArr = [];
    let count = 0;

    mdi_data[index].sort((a, b) => {
        if (typeof a !== 'string') {
            orderArr[count] = a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
            count += 1;

            return orderArr[count - 1];
        }

        return 0;
    });

    Object.keys(mdi_data).forEach((k) => {
        if (Number(k) !== index) {
            count = 0;
            mdi_data[k].sort((a, b) => {
                if (typeof a !== 'string') {
                    count += 1;

                    return orderArr[count - 1];
                }

                return 0;
            });
        }
    });

    count = 0;
    mdi_labels.sort(() => {
        count += 1;

        return orderArr[count - 1];
    });

    count = 0;
    mdi_sub_labels.sort(() => {
        count += 1;

        return orderArr[count - 1];
    });

    loadSelectLists();
    reloadSvg();
}

function trigger_label_media(x, stop_try) {
    reSortByMedia(x);
    showVertDrill(x, stop_try);
}

function trigger_label_criteria(y, stop_try) {
    reSortByCriteria(y);
    showHorizDrill(y, stop_try);
}

function drawSubSvg(x, y, data) {
    const txt_size_l = scale * txt_size;
    clearEl(byId('mdi_svg_sub-wrap'));

    const sub_height = 0.5 * block_size_global;
    svg_sub = createSvgFromHtml(
        `<svg height="${sub_height + txt_size_l * 2}" width="${width}" id="mdi_summary_svg_sub" class="mdi_svg" style="display:block;margin:auto;overflow:visible;"></svg>`,
    );

    let left = offset.x;
    const inner_width = block_size_global * Object.keys(mdi_data).length;

    appendHtml(
        svg_sub,
        `<text font-size="${txt_size_l}" text-anchor="end" x="${offset.x - txt_size_l / 2}" y="${(sub_height / 2) + txt_size_l / 2}" fill="white">${mdi_data[x][0]}</text>`,
    );

    if (data[2]) {
        data[2].forEach((v, k) => {
            let sub_width = inner_width * (v * mdi_sub_labels[y][k][0]);
            if (v <= 0.001) {
                sub_width = 5;
            }

            let colour = v > 1 ? 1 : v;
            if (mdi_labels[y] === 'Churn' || mdi_labels[y] === 'Regurg') {
                colour = 1 - colour;
            }

            appendHtml(
                svg_sub,
                `<rect class="mdi_hover" data-pct="<b>${mdi_sub_labels[y][k][1]}</b><br/>Scoring a rating of ${v}.<br>Weighting of ${mdi_sub_labels[y][k][0]}" x="${left}" y="0" height="${sub_height}" width="${sub_width}" stroke-width="1" stroke="white" fill="${getHEX(colour)}" />`,
            );

            left += sub_width;
        });
    }

    appendHtml(
        svg_sub,
        `<rect x="${left + 1}" y="0" height="${sub_height}" width="${inner_width - (left + 1) + offset.x}" stroke-width="1" stroke="black" fill="grey" />`,
    );

    const wrap = document.createElement('div');
    wrap.style.marginTop = '30px';
    wrap.insertAdjacentHTML(
        'beforeend',
        `<p class="desc-p" style="font-size:12px;text-align:center;margin-left:${offset.x}px"><b style="font-size:15px;">${mdi_labels[y]}</b><br>${mdi_descriptions[y] ?? ''}</p>`,
    );
    wrap.appendChild(svg_sub);

    const container = byId('mdi_svg_sub-wrap');
    container.appendChild(wrap);
    container.innerHTML = container.innerHTML;
}

function drawSubSvg2(x, y, data) {
    clearEl(byId('mdi_svg_sub2-wrap'));

    const sub_height = 0.5 * block_size_global;
    svg_sub = createSvgFromHtml(
        `<svg height="${sub_height + txt_size * 2}" width="${width}" id="mdi_summary_svg_sub2" class="mdi_svg" style="display:block;margin:auto;overflow:visible;"></svg>`,
    );

    let left = offset.x;
    const inner_width = block_size_global * Object.keys(mdi_data).length;

    appendHtml(
        svg_sub,
        `<text font-size="${txt_size}" text-anchor="end" x="${offset.x - txt_size / 2}" y="${sub_height / 2 + txt_size / 2}" fill="white">${mdi_data[x][0]}</text>`,
    );

    if (data[2]) {
        data[2].forEach((v, k) => {
            let sub_width = inner_width * (v * mdi_sub_labels[y][k][0]);
            if (v <= 0.001) {
                sub_width = 5;
            }

            let colour = v > 1 ? 1 : v;
            if (mdi_labels[y] === 'Churn' || mdi_labels[y] === 'Regurg') {
                colour = 1 - colour;
            }

            appendHtml(
                svg_sub,
                `<rect class="mdi_hover" data-pct="<b>${mdi_sub_labels[y][k][1]}</b><br/>Scoring a rating of ${v}.<br>Weighting of ${mdi_sub_labels[y][k][0]}" x="${left}" y="0" height="${sub_height}" width="${sub_width}" stroke-width="1" stroke="white" fill="${getHEX(colour)}" />`,
            );

            left += sub_width;
        });
    }

    appendHtml(
        svg_sub,
        `<rect x="${left + 1}" y="0" height="${sub_height}" width="${inner_width - (left + 1) + offset.x}" stroke-width="1" stroke="black" fill="grey" />`,
    );

    const wrap = document.createElement('div');
    wrap.appendChild(svg_sub);

    const container = byId('mdi_svg_sub2-wrap');
    container.appendChild(wrap);
    container.innerHTML = container.innerHTML;
}

function showDrill(elem, x, y) {
    if (prev !== null) {
        selected.setAttribute('x', prev.getAttribute('x'));
        selected.setAttribute('y', prev.getAttribute('y'));
        selected.setAttribute('height', prev.getAttribute('height'));
        selected.setAttribute('width', prev.getAttribute('width'));
        selected.setAttribute('stroke-width', prev.getAttribute('stroke-width'));
        selected.setAttribute('stroke', prev.getAttribute('stroke'));
    }

    selected = elem;
    prev = elem.cloneNode(true);

    selected.setAttribute('x', String(Number(selected.getAttribute('x')) - 2.5));
    selected.setAttribute('y', String(Number(selected.getAttribute('y')) - 2.5));
    selected.setAttribute('height', String(size + 5));
    selected.setAttribute('width', String(size + 5));
    selected.setAttribute('stroke-width', '5');
    selected.setAttribute('stroke', 'black');

    const focusUse = byId('mdi_focus_use');
    focusUse.setAttribute('data-pct', selected.getAttribute('data-pct'));
    focusUse.setAttribute('href', `#${x}_${y}`);

    const val_x = mdi_data[Object.keys(mdi_data)[x]];
    const val_x_y = val_x[Object.keys(val_x)[y + 1]];

    showVertDrill(x, true);
    showHorizDrill(y, true);
    drawSubSvg(x, y, val_x_y);
}

function showDrill2(elem, x, y) {
    if (prev2 !== null) {
        selected2.setAttribute('x', prev2.getAttribute('x'));
        selected2.setAttribute('y', prev2.getAttribute('y'));
        selected2.setAttribute('height', prev2.getAttribute('height'));
        selected2.setAttribute('width', prev2.getAttribute('width'));
        selected2.setAttribute('stroke-width', prev2.getAttribute('stroke-width'));
        selected2.setAttribute('stroke', prev2.getAttribute('stroke'));
    }

    selected2 = elem;
    prev2 = elem.cloneNode(true);

    selected2.setAttribute('x', String(Number(selected2.getAttribute('x')) - 2.5));
    selected2.setAttribute('y', String(Number(selected2.getAttribute('y')) - 2.5));
    selected2.setAttribute('height', String(size + 5));
    selected2.setAttribute('width', String(size + 5));
    selected2.setAttribute('stroke-width', '5');
    selected2.setAttribute('stroke', 'black');

    const focusUse2 = byId('mdi_focus_use2');
    focusUse2.setAttribute('data-pct', selected2.getAttribute('data-pct'));
    focusUse2.setAttribute('href', `#${x}_${y}`);

    const val_x = mdi_data[Object.keys(mdi_data)[x]];
    const val_x_y = val_x[Object.keys(val_x)[y + 1]];

    drawSubSvg2(x, y, val_x_y);
}

function toggleDrill(elem, x, y) {
    if (alter_y === null) {
        alter_y = y;
        alter_x = x;
        showDrill(elem, x, y);
    } else if (y === alter_y && x !== alter_x) {
        showDrill2(elem, x, y);
    } else {
        reset_selected2();
        alter_y = y;
        alter_x = x;
        showDrill(elem, x, y);
    }
}

function reloadSvg() {
    const wrap = byId('mdi_svg-wrap');
    wrap.style.height = wrap.style.height;
    clearEl(wrap);
    loadSvg();
}

function loadSvg() {
    const wrapContainer = byId('mdi_svg-wrap');
    width = wrapContainer.clientWidth;

    const limit = Object.keys(mdi_data).length;

    offset = {
        x: scale * 150,
        y: scale * 130,
    };
    size = scale * ((width - offset.x) / 100) * (100 / limit);
    block_size_global = size;

    const height = size * Object.keys(mdi_labels).length + offset.y;
    let inc = 0;
    const range = globalDataScale;
    txt_size = scale * scale * 16;

    svg = createSvgFromHtml(
        `<svg height="${height}" width="${width}" id="mdi_summary_svg_a" class="mdi_svg" style="display:block;margin:auto;"></svg>`,
    );

    const legend_size = size / 3;
    const legend_offset = { x: 10, y: 30 };
    const legend_buffer = 2;

    appendHtml(
        svg,
        `<rect x="${legend_offset.x}" y="${legend_offset.y}" height="${legend_size * 2 + 6}" width="${legend_size + 3 + scale * 80}" stroke-width="0" stroke="black" fill="none" />`,
    );
    appendHtml(
        svg,
        `<rect x="${legend_offset.x + legend_buffer}" y="${legend_offset.y + legend_buffer}" height="${legend_size}" width="${legend_size}" stroke-width="0.5" stroke="black" fill="${getHEX(1)}" />`,
    );
    appendHtml(
        svg,
        `<rect x="${legend_offset.x + legend_buffer}" y="${legend_size + legend_offset.y + legend_buffer * 2}" height="${legend_size}" width="${legend_size}" stroke-width="0.5" stroke="black" fill="${getHEX(0)}" />`,
    );
    appendHtml(
        svg,
        `<text font-size="${txt_size * 0.75}" text-anchor="start" x="${legend_size + legend_offset.x + legend_buffer * 3}" y="${legend_offset.y + legend_size / 2 + (txt_size * 0.75) / 2}" fill="white">More Diverse</text>`,
    );
    appendHtml(
        svg,
        `<text font-size="${txt_size * 0.75}" text-anchor="start" x="${legend_size + legend_offset.x + legend_buffer * 3}" y="${legend_offset.y + legend_size + legend_size / 2 + (txt_size * 0.75) / 2}" fill="white">Less Diverse</text>`,
    );

    mdi_labels.forEach((label, labelIndex) => {
        appendHtml(
            svg,
            `<rect x="0" y="${offset.y + size * labelIndex}" onclick="trigger_label_criteria(${labelIndex})" class="mdi_hover" height="${size}" width="${offset.x}" stroke-width="0" stroke="black" fill="${labelBackground}" />`,
        );
        appendHtml(
            svg,
            `<text font-size="${txt_size}" onclick="trigger_label_criteria(${labelIndex})" class="mdi_hover" text-anchor="end" data-y="${labelIndex}" x="${offset.x - txt_size}" y="${offset.y + size * labelIndex + size / 2 + txt_size / 2}" fill="white">${label}</text>`,
        );
    });

    Object.keys(mdi_data).forEach((k) => {
        const v = mdi_data[k];
        let counter = 0;
        let cur_label = '';

        Object.keys(v).forEach((kk) => {
            const vv = v[kk];

            if (kk === '0') {
                cur_label = vv;
            } else {
                const val = vv[0];
                const colour = vv[0] / range;
                const des = vv[1];

                if (counter === 0) {
                    const x = offset.x + size * (inc + 1) - size / 2 + txt_size / 2;
                    const y = offset.y + size * counter - txt_size;

                    appendHtml(
                        svg,
                        `<rect x="${offset.x + size * inc}" y="0" height="${offset.y}" onclick="trigger_label_media(${inc})" class="mdi_hover" width="${size}" stroke-width="0" stroke="black" fill="${labelBackground}" />`,
                    );
                    appendHtml(
                        svg,
                        `<text font-size="${txt_size}" onclick="trigger_label_media(${inc})" class="mdi_hover" text-anchor="start" data-x="${inc}" x="${x}" y="${y}" fill="white" transform="rotate(-90 ${x},${y})">${cur_label}</text>`,
                    );
                }

                appendHtml(
                    svg,
                    `<rect onclick="toggleDrill(this, ${inc}, ${counter})" class="mdi_hover" id="${inc}_${counter}" data-pct="<b>${cur_label} - ${mdi_labels[Number(kk) - 1]}</b><br/>${getDes(val, des)}" x="${offset.x + size * inc}" y="${offset.y + size * counter}" data-x="${inc}" data-y="${counter}" height="${size}" width="${size}" stroke-width="0" stroke="black" fill="${getHEX(colour)}" />`,
                );

                counter += 1;
            }
        });

        inc += 1;
    });

    appendHtml(
        svg,
        '<rect id="mdi_focus_rect" height="0" width="0" stroke-width="0" stroke="none" fill="none" />',
    );
    appendHtml(
        svg,
        '<rect id="mdi_focus_rect_horizontal" height="0" width="0" stroke-width="0" stroke="none" fill="none" />',
    );
    appendHtml(svg, '<use id="mdi_focus_use" class="mdi_hover" href=""/>');
    appendHtml(svg, '<use id="mdi_focus_use2" class="mdi_hover" href=""/>');

    const wrap = document.createElement('div');
    wrap.appendChild(svg);
    wrapContainer.appendChild(wrap);
    wrapContainer.innerHTML = wrapContainer.innerHTML;

    default_focus_use = byId('mdi_focus_use').cloneNode(true);
    default_focus_use2 = byId('mdi_focus_use2').cloneNode(true);
    default_focus_rect = byId('mdi_focus_rect').cloneNode(true);
    default_focus_rect_horizontal = byId('mdi_focus_rect_horizontal').cloneNode(true);
}

function bindTooltipEvents() {
    const tooltip = byId('mdi_tooltip');

    document.body.addEventListener('mousemove', (event) => {
        const target = event.target;
        const pct = target.getAttribute?.('data-pct');

        if (pct !== null && pct !== undefined) {
            tooltip.innerHTML = pct;
            tooltip.style.display = 'block';
        } else {
            tooltip.innerHTML = '';
            tooltip.style.display = 'none';
        }

        tooltip.style.top = `${event.pageY - tooltip.offsetHeight - 10}px`;
        tooltip.style.left = `${event.pageX - tooltip.offsetWidth / 2}px`;
    });

    document.body.addEventListener('click', (event) => {
        const target = event.target;
        const className = target.getAttribute?.('class') ?? '';

        if (!className.includes('mdi_hover')) {
            reset_selected();
            reset_selected2();
        }
    });

    document.body.addEventListener('click', (event) => {
        const target = event.target.closest?.('.mdi_hover');
        if (!target) {
            return;
        }

        const pct = target.getAttribute('data-pct');
        if (pct !== null) {
            tooltip.innerHTML = pct;
            tooltip.style.display = 'block';
            tooltip.style.top = `${event.pageY - tooltip.offsetHeight - 10}px`;
            tooltip.style.left = `${event.pageX - tooltip.offsetWidth / 2}px`;
        }
    });
}

async function initMdi(dataUrl) {
    bindTooltipEvents();

    const response = await fetch(dataUrl);
    const data = await response.json();

    mdi_data = data.data;
    mdi_labels = data.labels;
    mdi_sub_labels = data.sub_labels ?? [];
    mdi_descriptions = data.descriptions ?? [];

    window.mdi_data = mdi_data;

    loadSelectLists();
    loadSvg();
}

window.trigger_label_criteria = trigger_label_criteria;
window.trigger_label_media = trigger_label_media;
window.toggleDrill = toggleDrill;

const root = byId('mdi-root');
if (root) {
    const dataUrl = root.dataset.dataUrl;
    const boot = () => initMdi(dataUrl);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
}
